const awards = [
    { value: 'PHD', name: 'P.H.D' },
    { value: 'Masters', name: 'Masters' },
    { value: 'Degree', name: 'Degree' },
    { value: 'Diploma', name: 'Diploma' },
    { value: 'UACE', name: 'UACE' },
    { value: 'UCE', name: 'UCE' },
    { value: 'IPE', name: 'IPE' },
    { value: 'ISE', name: 'ISE' },
   
];


export  default awards